import styled from "styled-components"

// DEV NOTE: This styled component relates to standard and variant styles
export const Button = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`
